const getPartner = (key) => {
  const isDev = window.location.host.includes('develop') || window.location.host.includes('localhost');
  const src = isDev ? 'https://develop.omahapro.com/api/lang/partners' : 'https://omahapro.com/api/lang/partners';
  try {
    const response = fetch(
      src,
      {
        headers: {
          'Accept-Language': key,
        },
      },
    ).then((data) => data.json()).then((res) => res);

    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default getPartner;
